import React from 'react';
import { Container, Button, Alert, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { useTenant } from '../settings/TenantContext';
import { clearHomelessRedirectFlag } from '../lib/homelessInterceptor';

export default function NoSites() {
  const navigate = useNavigate();
  const { refreshMemberships, memberships } = useTenant();
  const [statusMsg, setStatusMsg] = React.useState('');
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => {
    clearHomelessRedirectFlag();
  }, []);

  React.useEffect(() => {
    if (Array.isArray(memberships) && memberships.length > 0) {
      navigate('/dashboard', { replace: true });
    }
  }, [memberships, navigate]);

  async function refreshAccess() {
    setBusy(true);
    try {
      await refreshMemberships();
      setStatusMsg('Looking for invitations or new tenants...');
    } catch (e) {
      setStatusMsg(e?.message || String(e));
    }
    setBusy(false);
  }

  async function logout() {
    setBusy(true);
    try {
      await supabase.auth.signOut();
      window.location.assign('/login');
    } catch (e) {
      setStatusMsg(e?.message || String(e));
      setBusy(false);
    }
  }

  return (
    <Container className="py-5">
      <div className="text-center mb-4">
        <h1 className="h3 fw-bold">No Active Sites</h1>
        <p className="text-muted">
          Your account is no longer associated with any tenants or sites. You can start a fresh workspace or request account removal.
        </p>
      </div>
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Card.Title>Create a New Site</Card.Title>
          <Card.Text>
            Launch the Getting Started wizard to create a new tenant and read your site content. You can invite teammates once it’s set up.
          </Card.Text>
          <Button
            variant="primary"
            onClick={() => navigate('/getting-started')}
            disabled={busy}
          >
            Create New Site
          </Button>
        </Card.Body>
      </Card>
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Card.Title>Request Account Deletion</Card.Title>
          <Card.Text>
            Prefer to delete your account instead? Contact us and we’ll take care of it for you.
          </Card.Text>
          <Button
            variant="outline-danger"
            href="mailto:support@theskinnyai.com?subject=Please%20delete%20my%20account"
          >
            Email Support
          </Button>
        </Card.Body>
      </Card>
      <Card className="mb-4 shadow-sm">
        <Card.Body>
          <Card.Title>Have an Invite?</Card.Title>
          <Card.Text>
            If a teammate invited you to another tenant, click refresh after accepting the invite email so we can reconnect your access.
          </Card.Text>
          <div className="d-flex gap-2 flex-wrap">
            <Button variant="outline-secondary" onClick={refreshAccess} disabled={busy}>
              Refresh Access
            </Button>
            <Button variant="outline-secondary" onClick={logout} disabled={busy}>
              Sign Out
            </Button>
          </div>
        </Card.Body>
      </Card>
      {statusMsg ? <Alert variant="info">{statusMsg}</Alert> : null}
    </Container>
  );
}

